import React from 'react';

import InputOptions from 'web/components/common/modal/Consulting/InputOptions';

import classNames from 'classnames/bind';
import styles from './Consulting.scss';
const cx = classNames.bind(styles);

const Consulting = React.memo(
  ({
    title = '',
    desc = '',
    formData = {},
    options = {},
    handleChange,
    handleSubmit,
    initModal,
  }) => {
    return (
      <div className={cx('Consulting')}>
        <div className="title">{title}</div>
        <div
          className="desc"
          dangerouslySetInnerHTML={{ __html: desc.replace('\n', '<br/>') }}
        />
        <form onSubmit={handleSubmit}>
          <InputOptions
            name="gender"
            data={formData.gender}
            value={options.gender}
            onChange={handleChange}
          />
          <InputOptions
            name="age"
            data={formData.age}
            value={options.age}
            onChange={handleChange}
          />
          <div className="buttons">
            <button type="button" onClick={initModal}>
              닫기
            </button>
            <button type="submit" onClick={handleSubmit}>
              제출하기
            </button>
          </div>
        </form>

        <span className={`close-btn-ico`} onClick={initModal}></span>
      </div>
    );
  },
);

export default Consulting;
